import { AssetType, Balance, ContractType, WalletInfosFragment } from '@blockpulse3/graphql/hooks';

import { MergedStockAssetByType } from './types';

export function getMergedBalances(
  balances: WalletInfosFragment['balances'],
): MergedStockAssetByType[] | undefined {
  if (!balances) return;

  const mergedB: MergedStockAssetByType[] = [];

  balances.forEach((balance) => {
    const { company, type, contractType } = balance.asset;

    /* ** Case where signer is a legal identity ** */
    const { signer, contact } = company;

    // Do not merge option token
    const isOptionToken = contractType === ContractType.OPTION_TOKEN;
    if (isOptionToken) {
      mergedB.push({
        company,
        balances: [balance as Balance],
        investAmount: balance.investedAmount,
        subscribedAmount: balance.subscribedAmount,
        subscribedAmountOrdinaryShare: 0,
        subscribedAmountPreferedShare: 0,
        contact,
        signer,
      });
      return;
    }

    // Merge stock token
    const balanceIndex = mergedB.findIndex(
      (b) =>
        b.company.registrationNumber === company.registrationNumber &&
        (b.balances[0].asset.contractType === ContractType.STOCK_TOKEN ||
          b.balances[0].asset.contractType === ContractType.BASIC_TOKEN),
    );
    if (balanceIndex < 0) {
      mergedB.push({
        company,
        balances: [balance as Balance],
        investAmount: balance.investedAmount,
        subscribedAmount: 0,
        subscribedAmountOrdinaryShare:
          type === AssetType.ORDINARY_SHARE ? balance.subscribedAmount : 0,
        subscribedAmountPreferedShare:
          type === AssetType.PREFERRED_SHARE ? balance.subscribedAmount : 0,
        contact,
        signer,
      });
    } else {
      mergedB[balanceIndex].balances.push(balance as Balance);
      mergedB[balanceIndex].investAmount += balance.investedAmount;
      if (type === AssetType.ORDINARY_SHARE) {
        mergedB[balanceIndex].subscribedAmountOrdinaryShare += balance.subscribedAmount;
      } else if (type === AssetType.PREFERRED_SHARE) {
        mergedB[balanceIndex].subscribedAmountPreferedShare += balance.subscribedAmount;
      } else {
        mergedB[balanceIndex].subscribedAmount += balance.subscribedAmount;
      }
    }
  });

  return mergedB.sort((a, b) => (a.company.name > b.company.name ? 1 : -1));
}
